<i18n>
{
    "ar": {
        "contact": {

            "name": "الاسم",
            "email": "البريد اﻹلكتروني",
            "title": "عنوان الرسالة",
            "content": "محتوى الرسالة",
            "send": "إرسال الرسالة",

            "message-sent": "تم اﻹرسال بنجاح، رسالتك رقم #{0}",
            "message-faild": "حدثت مشكلة أثناء اﻹرسال، أعد تحميل الصفحة وحاول مرة أخرى.",
            "empty": "لا يمكنك أن تترك حقلاً فارغاً.",
            "invalid-email": "البريد اﻹلكتروني الذي أدخلته غير صحيح.",

            "placeholders": {
                "name": "أدخل اسمك (اسم المرسل)",
                "email": "أدخل بريدك اﻹلكتروني",
                "title": "أدخل عنوان الرسالة",
                "content": "أدخل محتوى الرسالة"
            }
        }
    },
    "en": {
        "contact": {

            "email": "Email Address",
            "name": "Name",
            "title": "Message Subject",
            "content": "Message Content",
            "send": "Send Message",

            "message-sent": "Sent successfully! your message id is: #{0}",
            "message-faild": "Error occurred during sending, please reload page and try again.",
            "empty": "You must fill all inputs.",
            "invalid-email": "Email your entered is invalid.",
            
            "placeholders": {
                "name": "Enter Your Name",
                "email": "Enter Your Email Address",
                "title": "Enter Message Subject",
                "content": "Enter Message Content"
            }
        }
    }
}
</i18n>
<template>
<div>
    <div v-if="success || (errors && errors.length)" class="messages mb-4">
        <v-expand-transition appear>
            <v-alert v-if="success" dense text type="success" >{{success}}</v-alert>
            <v-alert v-else-if="errors && errors.length" dense text type="error" >
                <div v-for="(error, i) in errors" :key="i">{{error}}</div>
            </v-alert>
        </v-expand-transition>
    </div>
    <form>
        <v-row>
            <v-col :cols="pcOnly ? 6 : 12">
                <v-text-field v-model="name" :disabled="disabled" hide-details outlined :label="$t('contact.name')" :placeholder="$t('contact.placeholders.name')" />
            </v-col>
            <v-col :cols="pcOnly ? 6 : 12">
                <v-text-field v-model="email" :disabled="disabled" hide-details outlined :label="$t('contact.email')" :placeholder="$t('contact.placeholders.email')" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-text-field v-model="subject" :disabled="disabled" hide-details outlined :label="$t('contact.title')" :placeholder="$t('contact.placeholders.title')" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-textarea v-model="content" :disabled="disabled" rows="4" hide-details no-resize auto-grow outlined :label="$t('contact.content')" :placeholder="$t('contact.placeholders.content')" />
            </v-col>
        </v-row>
        <div class="contact-actions d-flex mt-4">
            <v-btn @click="submit" :loading="sending" :disabled="disabled" block x-large tile color="primary">
                <span>{{$t('contact.send')}}</span>
                <v-icon class="ms-3">mdi-arrow-{{isRtl ? 'left' : 'right'}}</v-icon>
            </v-btn>
        </div>
    </form>
</div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
export default {
    data(){
        return {
            sending: false,
            sentOnce: false,

            name: '',
            email: '',
            subject: '',
            content: '',

            errors: [],
            success: '',
        }
    },
    computed: {
        disabled(){
            let noToken = !this.homeData || !this.homeData.token;
            return this.sending || noToken || this.sentOnce;
        },
        data(){
            return {
                name: this.name,
                email: this.email.toLowerCase(),
                subject: this.subject,
                content: this.content
            }
        },
        ...GlobalComputed,
    },
    methods: {
        validate(){
            if (this.name && this.email && this.subject && this.content){
                if (this.checkEmail(this.email)){
                    this.resetMessages();
                    return true;
                }else{
                    this.errors = [this.$t('contact.invalid-email')];
                    return false;
                }
            }else{
                this.errors = [this.$t('contact.empty')];
                return false;
            }
        },
        checkEmail(email){
            const regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regEx.test(String(email).toLowerCase());
        },
        resetMessages(){
            this.success = '';
            this.errors = [];
        },
        resetForm(){
            this.name = '';
            this.email = '';
            this.subject = '';
            this.content = '';
        },
        submit(){
            if (this.validate()){
                this.sending = true;
                let data = this.data;
                window.axios.post('contact-us', {token: this.homeData.token, ...data}).then(response=>{
                    this.sending = false;
                    let id = response.data.id;
                    this.resetForm();
                    this.sentOnce = true;
                    this.success = this.$t('contact.message-sent', [id]);
                }).catch((error)=>{
                    window.console.log(error);
                    this.sending = false;
                    this.errors = [this.$t('contact.message-faild')];
                })
            }
        }
    },

}
</script>

<style lang="scss" scoped>

</style>